import React from 'react';
import {
  Box,
  Button,
} from '@mui/material';
import { APP_CONFIG } from '../../../../config/app.config';

interface WarehouseDataPreviewFooterProps {
  previewData: {
    columnMapping?: {
      ean?: string;
      quantity?: string;
    };
  };
  onClose: () => void;
  onConfirm: () => void;
}

const WarehouseDataPreviewFooter: React.FC<WarehouseDataPreviewFooterProps> = ({
  previewData,
  onClose,
  onConfirm,
}) => {
  const isConfirmDisabled = !previewData.columnMapping?.ean || !previewData.columnMapping?.quantity;

  const confirmButtonText = 'Confirm Mapping';

  return (
    <Box sx={{
      p: 3,
      borderTop: '1px solid',
      borderColor: APP_CONFIG.ui.theme.colors.border,
      display: 'flex',
      justifyContent: 'space-between',
      gap: 2
    }}>
      <Button onClick={onClose} variant="outlined">
        Cancel
      </Button>
      <Button
        variant="contained"
        disabled={isConfirmDisabled}
        onClick={onConfirm}
      >
        {confirmButtonText}
      </Button>
    </Box>
  );
};

export default WarehouseDataPreviewFooter; 